import { Box, Chip, Grid, Stack, Typography } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import moment from "moment";
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams, useSearchParams, useLocation } from 'react-router-dom';
import { getMilestonesPaymentStatus, verifyMilestonePayment } from './campaign_by_influencer/action';
import { ROUTES } from '../../utils/routes';

const CampaignByInfluencerDetailsForAdmin = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [campaign, setCampaign] = useState(null);
    const [milestones, setMilestones] = useState([]);

    useEffect(() => {
        const status = searchParams.get('status');
        const orderId = searchParams.get('order_id');
        console.log(status, orderId);

        if (status?.toLowerCase() === 'charged' && orderId) {
            dispatch(verifyMilestonePayment({ order_id: orderId })).then(() => {
                if (id) {
                    dispatch(getMilestonesPaymentStatus(id)).then((res) => {
                        if (res && res.data && res.data.result) {
                            if (res.data.result.milestones) setMilestones(res.data.result.milestones);
                            if (res.data.result.campaign) setCampaign(res.data.result.campaign);
                        }
                    });
                }
                navigate(location.pathname, { replace: true });
            });
        }
    }, [searchParams, dispatch, id, navigate, location.pathname]);

    useEffect(() => {
        if (id) {
            dispatch(getMilestonesPaymentStatus(id)).then((res) => {
                if (res && res.data && res.data.result) {
                    if (res.data.result.milestones) setMilestones(res.data.result.milestones);
                    if (res.data.result.campaign) setCampaign(res.data.result.campaign);
                }
            });
        }
    }, [id, dispatch]);

    const handlePayment = (link) => {
        if (link) window.open(link, '_blank');
    };

    return <>
        <Stack direction="row" alignItems="center" justifyContent={'space-between'} spacing={3} mb={2} >
            <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                sx={{
                    minHeight: '42px', paddingX: '16px'
                }}
            >
                <Typography variant="h1" component="h1">View Campaign Details</Typography>
                <Stack
                    className="backText"
                    direction={"row"}
                    gap={1}
                    alignItems={"center"}
                    sx={{ cursor: "pointer" }}
                    onClick={() => navigate(ROUTES.CAMPAIGN_BY_INFLUENCER_LIST)}
                >
                    <svg
                        width="16"
                        height="12"
                        viewBox="0 0 16 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.5 7.66667L5.16667 4.33333L8.5 1M4.33333 7.66667L1 4.33333L4.33333 1"
                            stroke="#0077FF"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M5.1665 4.33331H10.9998C11.8839 4.33331 12.7317 4.6845 13.3569 5.30962C13.982 5.93474 14.3332 6.78259 14.3332 7.66665C14.3332 8.5507 13.982 9.39855 13.3569 10.0237C12.7317 10.6488 11.8839 11 10.9998 11H10.1665"
                            stroke="#0077FF"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <Typography variant="h5" color={"primary"}>
                        Back
                    </Typography>
                </Stack>

            </Stack>
        </Stack>

        <Box
            p={3}
            sx={{
                backgroundColor: '#fff',
                transition: 'all .5s ease-in-out',
                position: 'relative',
                border: '1px solid rgba(170, 170, 170, 0.3)',
                borderRadius: '12px',
                boxShadow: '0px 5px 5px 0px rgba(82, 63, 105, 0.05)',
                overflow: 'hidden', marginX: '16px'
            }}
        >
            <Grid container>

                <Grid container rowGap={1} >

                    <Grid item xs={6} lg={6} md={6} sm={6} className='d-flex align-items-start justify-content-start' gap={2}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="subtitle1" gutterBottom>
                                <span className="label ">Campaign Name: </span>  <span className=" text-capitalize">{campaign?.campaignName || "-"}</span>
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={6} lg={6} md={6} sm={6} className='d-flex align-items-start justify-content-start' gap={2}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="subtitle1" gutterBottom>
                                <span className="label">Brand: </span>   {campaign?.brandName || "-"}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={6} lg={6} md={6} sm={6} className='d-flex align-items-start justify-content-start' gap={2}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="subtitle1" gutterBottom>
                                <span className="label">Company: </span>   {campaign?.companyName || "-"}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={6} lg={6} md={6} sm={6} className='d-flex align-items-start justify-content-start' gap={2}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="subtitle1" gutterBottom>
                                <span className="label">Influencer: </span>   {campaign?.influencerName || "-"}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={6} lg={6} md={6} sm={6} className='d-flex align-items-start justify-content-start' gap={2}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="subtitle1" gutterBottom>
                                <span className="label">Type: </span>  <span className="upperCase">{campaign?.type || "N/A"}</span>
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={6} lg={6} md={6} sm={6} className='d-flex align-items-start justify-content-start' gap={2}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="subtitle1" gutterBottom>
                                <span className="label">Total Amount: </span>  <span style={{ fontWeight: 600 }}>₹{campaign?.totalAmount}</span>
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={6} lg={6} md={6} sm={6} className='d-flex align-items-start justify-content-start' gap={2}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="subtitle1" gutterBottom>
                                <span className="label">Ends On: </span>  {campaign?.lastDateOfPayment ? moment(campaign.lastDateOfPayment).format("DD MMM YYYY") : "N/A"}
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={6} lg={6} md={6} sm={6} className='d-flex align-items-start justify-content-start' gap={2}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="subtitle1" gutterBottom>
                                <span className="label">Receiver Email: </span>  {campaign?.receiverEmail || "N/A"}
                            </Typography>
                        </Box>
                    </Grid>

                </Grid >

            </Grid >

        </Box >

        <Box
            mt={4}
            p={3}
            sx={{
                backgroundColor: '#fff',
                transition: 'all .5s ease-in-out',
                position: 'relative',
                border: '1px solid rgba(170, 170, 170, 0.3)',
                borderRadius: '12px',
                boxShadow: '0px 5px 5px 0px rgba(82, 63, 105, 0.05)',
                overflow: 'hidden', marginX: '16px',
            }}
        >
            <Grid container spacing={2}  >
                <Grid item xs={12} md={12} lg={12} sm={12}>
                    <Typography variant="h5" mb={1} sx={{ fontWeight: 600, color: '#444' }}>Description</Typography>
                    <Typography variant="body1" paragraph>
                        {campaign?.campaignDescription ? <span dangerouslySetInnerHTML={{ __html: campaign?.campaignDescription }} ></span> : "N/A"}
                    </Typography>
                </Grid>
            </Grid>
        </Box>

        <Box
            mt={4}
            p={3}
            sx={{
                backgroundColor: '#fff',
                transition: 'all .5s ease-in-out',
                position: 'relative',
                border: '1px solid rgba(170, 170, 170, 0.3)',
                borderRadius: '12px',
                boxShadow: '0px 5px 5px 0px rgba(82, 63, 105, 0.05)',
                overflow: 'hidden', marginX: '16px',
            }}
        >
            <Typography variant="h5" mb={3} sx={{ fontWeight: 600, color: '#444' }}>Milestones</Typography>
            <Grid container spacing={2}>
                {milestones.length > 0 ? milestones.map((milestone, index) => (
                    <Grid item xs={12} key={index}>
                        <Box sx={{
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            p: 2,
                            backgroundColor: '#fafafa'
                        }}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center" spacing={2}>
                                <Stack spacing={0.5}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{milestone.title}</Typography>
                                    <Typography variant="body2" color="textSecondary">{milestone.description}</Typography>
                                    <Typography variant="caption" color="textSecondary">
                                        Due Date: {milestone.lastDateOfPayment ? moment(milestone.lastDateOfPayment).format("DD MMM YYYY") : "N/A"}
                                    </Typography>
                                </Stack>

                                <Stack direction="row" alignItems="center" spacing={3}>
                                    <Typography variant="h6" color="primary">₹{milestone.amount}</Typography>

                                    {milestone.paymentStatus === 'completed' ? (
                                        <Chip label="Paid" color="success" onClick={() => milestone.invoiceUrl && window.open(milestone.invoiceUrl, '_blank')} clickable={!!milestone.invoiceUrl} />
                                    ) : milestone.paymentStatus === 'expired' ? (
                                        <Chip label="Expired" color="error" />
                                    ) : (
                                        <button
                                            className='btnPrimary'
                                            onClick={() => handlePayment(milestone.paymentLink)}
                                            style={{ minWidth: '100px' }}
                                            disabled={!milestone.paymentLink}
                                        >
                                            Pay Now
                                        </button>
                                    )}
                                </Stack>
                            </Stack>
                        </Box>
                    </Grid>
                )) : (
                    <Grid item xs={12}>
                        <Typography variant="body1" align="center" color="textSecondary">No milestones found.</Typography>
                    </Grid>
                )}
            </Grid>
        </Box>
    </>
};
export default CampaignByInfluencerDetailsForAdmin;
